var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            {
              staticClass: "code-row-bg",
              attrs: { type: "flex", justify: "space-between" }
            },
            [
              _c(
                "Col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "Row",
                    [
                      _c(
                        "Form",
                        {
                          ref: "searchForm",
                          staticClass: "search-form",
                          attrs: {
                            model: _vm.searchForm,
                            inline: "",
                            "label-width": 70
                          }
                        },
                        [
                          _c(
                            "Form-item",
                            { attrs: { label: "名称", prop: "name" } },
                            [
                              _c("Input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.searchForm.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "name", $$v)
                                  },
                                  expression: "searchForm.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            { attrs: { label: "类型", prop: "typeId" } },
                            [
                              _c(
                                "Select",
                                {
                                  staticStyle: { width: "200px" },
                                  model: {
                                    value: _vm.searchForm.typeId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.searchForm, "typeId", $$v)
                                    },
                                    expression: "searchForm.typeId"
                                  }
                                },
                                _vm._l(_vm.typeArr, function(item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.title,
                                      attrs: { value: item.id }
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  )
                                })
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "Form-item",
                            {
                              staticClass: "br",
                              staticStyle: { "margin-left": "-35px" }
                            },
                            [
                              _c(
                                "Button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "ios-search"
                                  },
                                  on: { click: _vm.handleSearch }
                                },
                                [_vm._v("搜索")]
                              ),
                              _vm._v(" "),
                              _c("Button", { on: { click: _vm.handleReset } }, [
                                _vm._v("重置")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    [
                      _c("Table", {
                        ref: "table",
                        attrs: {
                          loading: _vm.loading,
                          border: "",
                          columns: _vm.columns,
                          data: _vm.data,
                          sortable: "custom"
                        },
                        on: { "on-sort-change": _vm.changeSort }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Row",
                    {
                      staticClass: "page",
                      attrs: { type: "flex", justify: "end" }
                    },
                    [
                      _c("Page", {
                        attrs: {
                          current: _vm.searchForm.pageNo,
                          total: _vm.total,
                          "page-size": _vm.searchForm.pageSize,
                          "page-size-opts": [10, 20, 50],
                          size: "small",
                          "show-total": "",
                          "show-elevator": "",
                          "show-sizer": ""
                        },
                        on: {
                          "on-change": _vm.changePage,
                          "on-page-size-change": _vm.changePageSize
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          staticClass: "formModel",
          attrs: {
            title: "合同归档",
            "mask-closable": false,
            width: 1000,
            styles: { top: "30px" }
          },
          on: { "on-cancel": _vm.handleModelClose },
          model: {
            value: _vm.modalVisible,
            callback: function($$v) {
              _vm.modalVisible = $$v
            },
            expression: "modalVisible"
          }
        },
        [
          _c(
            "Form",
            {
              ref: "dictForm",
              attrs: {
                model: _vm.dictForm,
                "label-width": 120,
                rules: _vm.dictFormValidate
              }
            },
            [
              _c(
                "div",
                { staticClass: "ul" },
                [
                  _c(
                    "FormItem",
                    {
                      staticClass: "lef",
                      attrs: { label: "档案编号", prop: "number" }
                    },
                    [
                      _c("Input", {
                        staticStyle: { width: "320px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.dictForm.number,
                          callback: function($$v) {
                            _vm.$set(_vm.dictForm, "number", $$v)
                          },
                          expression: "dictForm.number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Form-item",
                    {
                      staticClass: "lef",
                      attrs: { label: "档案保管时间", prop: "keepTime" }
                    },
                    [
                      _c("DatePicker", {
                        staticStyle: { width: "320px" },
                        attrs: {
                          type: "date",
                          format: "yyyy-MM-dd",
                          placeholder: "选择时间"
                        },
                        model: {
                          value: _vm.dictForm.keepTime,
                          callback: function($$v) {
                            _vm.$set(_vm.dictForm, "keepTime", $$v)
                          },
                          expression: "dictForm.keepTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ul" },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "档案保管人", prop: "archivist" } },
                    [
                      _c(
                        "Input",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { placeholder: "请选择" },
                          on: { "on-focus": _vm.handleArchivist },
                          model: {
                            value: _vm.dictForm.archivist,
                            callback: function($$v) {
                              _vm.$set(_vm.dictForm, "archivist", $$v)
                            },
                            expression: "dictForm.archivist"
                          }
                        },
                        [
                          _c("Button", {
                            attrs: { slot: "append", icon: "ios-arrow-down" },
                            on: { click: _vm.handleArchivist },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Form-item",
                {
                  staticClass: "lef",
                  staticStyle: { width: "900px" },
                  attrs: { label: "归档材料清单", prop: "isTopayList" }
                },
                [
                  _c("span", { staticClass: "list-icon" }),
                  _vm._v(" "),
                  _c(
                    "CheckboxGroup",
                    {
                      model: {
                        value: _vm.isTopayList,
                        callback: function($$v) {
                          _vm.isTopayList = $$v
                        },
                        expression: "isTopayList"
                      }
                    },
                    [
                      _c("Checkbox", { attrs: { label: "合同正文" } }),
                      _vm._v(" "),
                      _c("Checkbox", { attrs: { label: "合同相关附件" } }),
                      _vm._v(" "),
                      _c("Checkbox", { attrs: { label: "我方授权委托书" } }),
                      _vm._v(" "),
                      _c("Checkbox", { attrs: { label: "对方授权委托书" } }),
                      _vm._v(" "),
                      _c("Checkbox", { attrs: { label: "其他" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "相关附件" } },
                    [
                      _c(
                        "Upload",
                        {
                          ref: "upload2",
                          staticClass: "upload",
                          staticStyle: { width: "810px" },
                          attrs: {
                            action:
                              "/zhfw/system/upload/uploadFiles?tag=accessoryurl-attachmentname",
                            headers: _vm.accessToken,
                            "show-upload-list": false,
                            "default-file-list": _vm.defaultList,
                            "on-success": _vm.affixHandleSuccess,
                            "max-size": 51200,
                            "on-exceeded-size": _vm.affixHandleMaxSize,
                            "before-upload": _vm.affixhandleBeforeUpload,
                            multiple: "",
                            type: "drag"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "upload",
                              attrs: { id: "attachmentname" },
                              on: {
                                click: function($event) {
                                  _vm.getUpId("attachmentname")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            \t\t上传文件\n                        "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticStyle: { color: "#d3d3d3" } }, [
                        _vm._v("支持文件大小：<=50MB")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.uploadList, function(item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "demo-upload-list" },
                          [
                            _c(
                              "div",
                              { staticClass: "demo-upload-list-cover" },
                              [
                                [
                                  _c("p", { staticClass: "affixList" }, [
                                    _c(
                                      "a",
                                      { attrs: { href: item.fileDownUrl } },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("Icon", {
                                    attrs: { type: "ios-close-circle" },
                                    nativeOn: {
                                      click: function($event) {
                                        _vm.handleRemove(item)
                                      }
                                    }
                                  })
                                ]
                              ],
                              2
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ul" },
                [
                  _c(
                    "FormItem",
                    {
                      staticStyle: { width: "930px" },
                      attrs: { label: "备注", prop: "remark" }
                    },
                    [
                      _c("Input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.dictForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.dictForm, "remark", $$v)
                          },
                          expression: "dictForm.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { clear: "both" } }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "text" },
                  on: { click: _vm.handleModelClose }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { loading: _vm.btnLoading, type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.planConfirm("dictForm")
                    }
                  }
                },
                [
                  !_vm.btnLoading
                    ? _c("span", [_vm._v("提交")])
                    : _c("span", [_vm._v("Loading...")])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          staticClass: "model-apply",
          attrs: { title: "组织机构选人", "mask-closable": false, width: 700 },
          model: {
            value: _vm.applyModalVisible,
            callback: function($$v) {
              _vm.applyModalVisible = $$v
            },
            expression: "applyModalVisible"
          }
        },
        [
          _c(
            "div",
            { staticClass: "clear" },
            [
              _c(
                "Col",
                { attrs: { span: 24 } },
                [
                  _c("Col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "tree-bar" },
                      [
                        _c("Tree", {
                          ref: "tree",
                          attrs: {
                            data: _vm.treeData,
                            "load-data": _vm.loadData
                          },
                          on: { "on-select-change": _vm.selectTree }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: 12 } },
                    [
                      _c("Alert", { attrs: { "show-icon": "" } }, [
                        _vm._v(
                          "\n                        已选择\n                        "
                        ),
                        _c("span", { staticClass: "select-count" }, [
                          _vm._v(_vm._s(_vm.selectCount))
                        ]),
                        _vm._v(
                          "\n                        项\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("Table", {
                        ref: "table1",
                        attrs: {
                          height: 300,
                          loading: _vm.loading,
                          "highlight-row": "",
                          border: "",
                          columns: _vm.columns1,
                          data: _vm.personData
                        },
                        on: { "on-current-change": _vm.showSelect2 }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { clear: "both" } }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                { attrs: { type: "text" }, on: { click: _vm.handelCancel } },
                [_vm._v("取消")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }